import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin') {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const register = (email, password, setup_key) => api.post('/auth/register', { email, password, setup_key });
export const getMe = () => api.get('/auth/me');

// Packages
export const getPackages = () => api.get('/packages');
export const createPackage = (data) => api.post('/packages', data);
export const updatePackage = (id, data) => api.put(`/packages/${id}`, data);
export const deletePackage = (id) => api.delete(`/packages/${id}`);

// Media
export const getMedia = () => api.get('/media');
export const createMedia = (data) => api.post('/media', data);
export const updateMedia = (id, data) => api.put(`/media/${id}`, data);
export const deleteMedia = (id) => api.delete(`/media/${id}`);

// FAQs
export const getFAQs = () => api.get('/faqs');
export const createFAQ = (data) => api.post('/faqs', data);
export const updateFAQ = (id, data) => api.put(`/faqs/${id}`, data);
export const deleteFAQ = (id) => api.delete(`/faqs/${id}`);

// Reviews
export const getReviews = () => api.get('/reviews');
export const createReview = (data) => api.post('/reviews', data);
export const updateReview = (id, data) => api.put(`/reviews/${id}`, data);
export const deleteReview = (id) => api.delete(`/reviews/${id}`);

// About
export const getAbout = () => api.get('/about');
export const updateAbout = (data) => api.put('/about', data);

// Widgets
export const getWidgets = () => api.get('/widgets');
export const getWidget = (id) => api.get(`/widgets/${id}`);
export const updateWidget = (id, data) => api.put(`/widgets/${id}`, data);

// Settings
export const getSettings = () => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);

// YouTube Import
export const importYouTubeChannel = (channel_url) => api.post('/youtube/import-channel', { channel_url });

// Reorder
export const reorderPackages = (items) => api.put('/packages/reorder', { items });
export const reorderFAQs = (items) => api.put('/faqs/reorder', { items });

// Health
export const healthCheck = () => api.get('/health');

// Analytics
export const getAnalyticsSummary = () => api.get('/analytics/summary');
export const trackPageView = (page, referrer, userAgent) => {
  const sessionId = sessionStorage.getItem('session_id') || (() => {
    const id = crypto.randomUUID();
    sessionStorage.setItem('session_id', id);
    return id;
  })();
  
  return api.post('/analytics/track', 
    { page, referrer, user_agent: userAgent },
    { headers: { 'x-session-id': sessionId } }
  );
};

export default api;
